import { default as indexWAanGACwoHMeta } from "/home/binaffan.com/nuxt-frontend/pages/[catSlug]-a[catId]/index.vue?macro=true";
import { default as auth_46clientEo0AQX8ElVMeta } from "/home/binaffan.com/nuxt-frontend/pages/auth.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/home/binaffan.com/nuxt-frontend/node_modules/nuxt/dist/components/runtime/client-component").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as adreslerim_45newbRAKmDo43LMeta } from "/home/binaffan.com/nuxt-frontend/pages/hesap/adreslerim-new.vue?macro=true";
import { default as adreslerim_46clientd7ZgwltuqEMeta } from "/home/binaffan.com/nuxt-frontend/pages/hesap/adreslerim.client.vue?macro=true";
import { default as ayarlarh6e3XPrimPMeta } from "/home/binaffan.com/nuxt-frontend/pages/hesap/ayarlar.vue?macro=true";
import { default as favorilerimcsjl1rW1fvMeta } from "/home/binaffan.com/nuxt-frontend/pages/hesap/favorilerim.vue?macro=true";
import { default as logoutrwt7CsmrTRMeta } from "/home/binaffan.com/nuxt-frontend/pages/hesap/logout.vue?macro=true";
import { default as _91id_93_46client5qnCeXSUTcMeta } from "/home/binaffan.com/nuxt-frontend/pages/hesap/siparislerim/[id].client.vue?macro=true";
import { default as indexlyQsDlV7kqMeta } from "/home/binaffan.com/nuxt-frontend/pages/hesap/siparislerim/index.vue?macro=true";
import { default as indexVNjBZe17nYMeta } from "/home/binaffan.com/nuxt-frontend/pages/index.vue?macro=true";
import { default as _91slug_93_45c_91id_93PirwEImAKPMeta } from "/home/binaffan.com/nuxt-frontend/pages/katalog/[slug]-c[id].vue?macro=true";
import { default as aramafcVwlCdwT7Meta } from "/home/binaffan.com/nuxt-frontend/pages/katalog/arama.vue?macro=true";
import { default as _91slug_93_45m_45_91id_93av0pJsaaxgMeta } from "/home/binaffan.com/nuxt-frontend/pages/magaza/[slug]-m-[id].vue?macro=true";
import { default as admin_45loginepuKUoVWFFMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin-login.vue?macro=true";
import { default as ayarlar0YcNj3xaAwMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/ayarlar.vue?macro=true";
import { default as _91id_937lNqpgTWU7Meta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/bolgeler/[id].vue?macro=true";
import { default as _91id_93Jlv4BrukV8Meta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/bolgeler/ilce/[id].vue?macro=true";
import { default as indexuje6E7ebyUMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/bolgeler/index.vue?macro=true";
import { default as senkronizasyonVzzynRI9pqMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/bolgeler/senkronizasyon.vue?macro=true";
import { default as manuel_45islemlerIDspiTf6BbMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/elasticsearch/manuel-islemler.vue?macro=true";
import { default as duzenleWMpX0nxa6TMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/kargo/kargo-firmalari/[id]/duzenle.vue?macro=true";
import { default as ekleTh77UOwvq3Meta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/kargo/kargo-firmalari/ekle.vue?macro=true";
import { default as indexwVtcFTH8qfMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/kargo/kargo-firmalari/index.vue?macro=true";
import { default as duzenlen9Uv8AsA0nMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/kargo/saglayicilar/[id]/duzenle.vue?macro=true";
import { default as ekleFl62PpNMAmMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/kargo/saglayicilar/ekle.vue?macro=true";
import { default as indexW9bpz3WcFpMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/kargo/saglayicilar/index.vue?macro=true";
import { default as duzenleIqtIqnizxbMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/kategoriler/[id]/duzenle.vue?macro=true";
import { default as eklegZLCvYgXFKMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/kategoriler/ekle.vue?macro=true";
import { default as indexNcG3WO1Q38Meta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/kategoriler/index.vue?macro=true";
import { default as trendyol_45uyarlamafAH0IGY2gjMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/komisyon/trendyol-uyarlama.vue?macro=true";
import { default as duzenlegPSkUJAL04Meta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/nitelikler/[id]/duzenle.vue?macro=true";
import { default as eklexx0FlofL0SMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/nitelikler/ekle.vue?macro=true";
import { default as indexzQtOMDA6BDMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/nitelikler/index.vue?macro=true";
import { default as site_45sagligi5vlownmnnFMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/admin/teknik-islemler/site-sagligi.vue?macro=true";
import { default as _91id_93MRCaFUshbUMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/basvurular/[id].vue?macro=true";
import { default as indexwriSkAGSQAMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/basvurular/index.vue?macro=true";
import { default as eksiklerJvtA1UzKa5Meta } from "/home/binaffan.com/nuxt-frontend/pages/management/eksikler.vue?macro=true";
import { default as indexdvPcpxcRI1Meta } from "/home/binaffan.com/nuxt-frontend/pages/management/index.vue?macro=true";
import { default as _91id_93sMtE6fSqAUMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/karoseller/[id].vue?macro=true";
import { default as eklebSENDxrwiBMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/karoseller/ekle.vue?macro=true";
import { default as index5aoxe1DmwLMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/karoseller/index.vue?macro=true";
import { default as loginzwRU48klKjMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/login.vue?macro=true";
import { default as indexISWOtJoOcBMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/magazam/adresler/index.vue?macro=true";
import { default as adreslerCc7BR8cOHSMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/magazam/ayarlar/adresler.vue?macro=true";
import { default as banka_45ayarlarivETe640mdUMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/magazam/ayarlar/banka-ayarlari.vue?macro=true";
import { default as iletisim47cSClw0nPMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/magazam/ayarlar/iletisim.vue?macro=true";
import { default as indexa9t0Rpsl3KMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/magazam/ayarlar/index.vue?macro=true";
import { default as profilbiuEBuoNBvMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/magazam/ayarlar/profil.vue?macro=true";
import { default as sirket_45bilgilerijVzYoanZLpMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/magazam/ayarlar/sirket-bilgileri.vue?macro=true";
import { default as _91id_93XYCihveGIlMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/markalar/[id].vue?macro=true";
import { default as eklewOck3IsX0ZMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/markalar/ekle.vue?macro=true";
import { default as indexrVcaQYBcXMMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/markalar/index.vue?macro=true";
import { default as _91id_931AE0eUV4M3Meta } from "/home/binaffan.com/nuxt-frontend/pages/management/siparisler/[id].vue?macro=true";
import { default as indexFoeVnhP0G9Meta } from "/home/binaffan.com/nuxt-frontend/pages/management/siparisler/index.vue?macro=true";
import { default as _91id_93fniQ7ErrBEMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/urunler/[id].vue?macro=true";
import { default as indexf5oTDSTuFFMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/urunler/index.vue?macro=true";
import { default as urun_45ekleoz9fJkWF6CMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/urunler/urun-ekle.vue?macro=true";
import { default as index7I8GJ9OUMfMeta } from "/home/binaffan.com/nuxt-frontend/pages/management/uyeler/index.vue?macro=true";
import { default as yeniFMQRCWwVQsMeta } from "/home/binaffan.com/nuxt-frontend/pages/markalar/yeni.vue?macro=true";
import { default as odeme9QChTVye0BMeta } from "/home/binaffan.com/nuxt-frontend/pages/odeme.vue?macro=true";
import { default as sepetsUvJ8TpuaaMeta } from "/home/binaffan.com/nuxt-frontend/pages/sepet.vue?macro=true";
import { default as sifremi_45unuttum_46clientrVKWq0ma9cMeta } from "/home/binaffan.com/nuxt-frontend/pages/sifremi-unuttum.client.vue?macro=true";
import { default as sikca_45sorulan_45sorularuhnm35HhA8Meta } from "/home/binaffan.com/nuxt-frontend/pages/sikca-sorulan-sorular.vue?macro=true";
import { default as tesekkurler_46clientqPwFqBkWnRMeta } from "/home/binaffan.com/nuxt-frontend/pages/tesekkurler.client.vue?macro=true";
import { default as indexq6UrEVlSLUMeta } from "/home/binaffan.com/nuxt-frontend/pages/tuccar/basvuru/pazaryeri/index.vue?macro=true";
import { default as tesekkurlerEZdmHprbR8Meta } from "/home/binaffan.com/nuxt-frontend/pages/tuccar/basvuru/tesekkurler.vue?macro=true";
import { default as _91slug_937puzyB9I8zMeta } from "/home/binaffan.com/nuxt-frontend/pages/urun/[brand]/[slug].vue?macro=true";
import { default as _91slug_93_45_45_91urlParams_93HrHeX22TAhMeta } from "/home/binaffan.com/nuxt-frontend/pages/urun/[slug]--[urlParams].vue?macro=true";
export default [
  {
    name: "catSlug-acatId",
    path: "/:catSlug()-a:catId()",
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/[catSlug]-a[catId]/index.vue").then(m => m.default || m)
  },
  {
    name: "auth",
    path: "/auth",
    component: () => createClientPage(() => import("/home/binaffan.com/nuxt-frontend/pages/auth.client.vue").then(m => m.default || m))
  },
  {
    name: "hesap-adreslerim-new",
    path: "/hesap/adreslerim-new",
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/hesap/adreslerim-new.vue").then(m => m.default || m)
  },
  {
    name: "hesap-adreslerim",
    path: "/hesap/adreslerim",
    component: () => createClientPage(() => import("/home/binaffan.com/nuxt-frontend/pages/hesap/adreslerim.client.vue").then(m => m.default || m))
  },
  {
    name: "hesap-ayarlar",
    path: "/hesap/ayarlar",
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/hesap/ayarlar.vue").then(m => m.default || m)
  },
  {
    name: "hesap-favorilerim",
    path: "/hesap/favorilerim",
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/hesap/favorilerim.vue").then(m => m.default || m)
  },
  {
    name: "hesap-logout",
    path: "/hesap/logout",
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/hesap/logout.vue").then(m => m.default || m)
  },
  {
    name: "hesap-siparislerim-id",
    path: "/hesap/siparislerim/:id()",
    component: () => createClientPage(() => import("/home/binaffan.com/nuxt-frontend/pages/hesap/siparislerim/[id].client.vue").then(m => m.default || m))
  },
  {
    name: "hesap-siparislerim",
    path: "/hesap/siparislerim",
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/hesap/siparislerim/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "katalog-slug-cid",
    path: "/katalog/:slug()-c:id()",
    meta: _91slug_93_45c_91id_93PirwEImAKPMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/katalog/[slug]-c[id].vue").then(m => m.default || m)
  },
  {
    name: "katalog-arama",
    path: "/katalog/arama",
    meta: aramafcVwlCdwT7Meta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/katalog/arama.vue").then(m => m.default || m)
  },
  {
    name: "magaza-slug-m-id",
    path: "/magaza/:slug()-m-:id()",
    meta: _91slug_93_45m_45_91id_93av0pJsaaxgMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/magaza/[slug]-m-[id].vue").then(m => m.default || m)
  },
  {
    name: "management-admin-login",
    path: "/management/admin-login",
    meta: admin_45loginepuKUoVWFFMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin-login.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-ayarlar",
    path: "/management/admin/ayarlar",
    meta: ayarlar0YcNj3xaAwMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/ayarlar.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-bolgeler-id",
    path: "/management/admin/bolgeler/:id()",
    meta: _91id_937lNqpgTWU7Meta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/bolgeler/[id].vue").then(m => m.default || m)
  },
  {
    name: "management-admin-bolgeler-ilce-id",
    path: "/management/admin/bolgeler/ilce/:id()",
    meta: _91id_93Jlv4BrukV8Meta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/bolgeler/ilce/[id].vue").then(m => m.default || m)
  },
  {
    name: "management-admin-bolgeler",
    path: "/management/admin/bolgeler",
    meta: indexuje6E7ebyUMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/bolgeler/index.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-bolgeler-senkronizasyon",
    path: "/management/admin/bolgeler/senkronizasyon",
    meta: senkronizasyonVzzynRI9pqMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/bolgeler/senkronizasyon.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-elasticsearch-manuel-islemler",
    path: "/management/admin/elasticsearch/manuel-islemler",
    meta: manuel_45islemlerIDspiTf6BbMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/elasticsearch/manuel-islemler.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-kargo-kargo-firmalari-id-duzenle",
    path: "/management/admin/kargo/kargo-firmalari/:id()/duzenle",
    meta: duzenleWMpX0nxa6TMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/kargo/kargo-firmalari/[id]/duzenle.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-kargo-kargo-firmalari-ekle",
    path: "/management/admin/kargo/kargo-firmalari/ekle",
    meta: ekleTh77UOwvq3Meta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/kargo/kargo-firmalari/ekle.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-kargo-kargo-firmalari",
    path: "/management/admin/kargo/kargo-firmalari",
    meta: indexwVtcFTH8qfMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/kargo/kargo-firmalari/index.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-kargo-saglayicilar-id-duzenle",
    path: "/management/admin/kargo/saglayicilar/:id()/duzenle",
    meta: duzenlen9Uv8AsA0nMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/kargo/saglayicilar/[id]/duzenle.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-kargo-saglayicilar-ekle",
    path: "/management/admin/kargo/saglayicilar/ekle",
    meta: ekleFl62PpNMAmMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/kargo/saglayicilar/ekle.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-kargo-saglayicilar",
    path: "/management/admin/kargo/saglayicilar",
    meta: indexW9bpz3WcFpMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/kargo/saglayicilar/index.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-kategoriler-id-duzenle",
    path: "/management/admin/kategoriler/:id()/duzenle",
    meta: duzenleIqtIqnizxbMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/kategoriler/[id]/duzenle.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-kategoriler-ekle",
    path: "/management/admin/kategoriler/ekle",
    meta: eklegZLCvYgXFKMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/kategoriler/ekle.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-kategoriler",
    path: "/management/admin/kategoriler",
    meta: indexNcG3WO1Q38Meta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/kategoriler/index.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-komisyon-trendyol-uyarlama",
    path: "/management/admin/komisyon/trendyol-uyarlama",
    meta: trendyol_45uyarlamafAH0IGY2gjMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/komisyon/trendyol-uyarlama.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-nitelikler-id-duzenle",
    path: "/management/admin/nitelikler/:id()/duzenle",
    meta: duzenlegPSkUJAL04Meta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/nitelikler/[id]/duzenle.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-nitelikler-ekle",
    path: "/management/admin/nitelikler/ekle",
    meta: eklexx0FlofL0SMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/nitelikler/ekle.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-nitelikler",
    path: "/management/admin/nitelikler",
    meta: indexzQtOMDA6BDMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/nitelikler/index.vue").then(m => m.default || m)
  },
  {
    name: "management-admin-teknik-islemler-site-sagligi",
    path: "/management/admin/teknik-islemler/site-sagligi",
    meta: site_45sagligi5vlownmnnFMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/admin/teknik-islemler/site-sagligi.vue").then(m => m.default || m)
  },
  {
    name: "management-basvurular-id",
    path: "/management/basvurular/:id()",
    meta: _91id_93MRCaFUshbUMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/basvurular/[id].vue").then(m => m.default || m)
  },
  {
    name: "management-basvurular",
    path: "/management/basvurular",
    meta: indexwriSkAGSQAMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/basvurular/index.vue").then(m => m.default || m)
  },
  {
    name: "management-eksikler",
    path: "/management/eksikler",
    meta: eksiklerJvtA1UzKa5Meta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/eksikler.vue").then(m => m.default || m)
  },
  {
    name: "management",
    path: "/management",
    meta: indexdvPcpxcRI1Meta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/index.vue").then(m => m.default || m)
  },
  {
    name: "management-karoseller-id",
    path: "/management/karoseller/:id()",
    meta: _91id_93sMtE6fSqAUMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/karoseller/[id].vue").then(m => m.default || m)
  },
  {
    name: "management-karoseller-ekle",
    path: "/management/karoseller/ekle",
    meta: eklebSENDxrwiBMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/karoseller/ekle.vue").then(m => m.default || m)
  },
  {
    name: "management-karoseller",
    path: "/management/karoseller",
    meta: index5aoxe1DmwLMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/karoseller/index.vue").then(m => m.default || m)
  },
  {
    name: "management-login",
    path: "/management/login",
    meta: loginzwRU48klKjMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/login.vue").then(m => m.default || m)
  },
  {
    name: "management-magazam-adresler",
    path: "/management/magazam/adresler",
    meta: indexISWOtJoOcBMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/magazam/adresler/index.vue").then(m => m.default || m)
  },
  {
    name: "management-magazam-ayarlar-adresler",
    path: "/management/magazam/ayarlar/adresler",
    meta: adreslerCc7BR8cOHSMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/magazam/ayarlar/adresler.vue").then(m => m.default || m)
  },
  {
    name: "management-magazam-ayarlar-banka-ayarlari",
    path: "/management/magazam/ayarlar/banka-ayarlari",
    meta: banka_45ayarlarivETe640mdUMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/magazam/ayarlar/banka-ayarlari.vue").then(m => m.default || m)
  },
  {
    name: "management-magazam-ayarlar-iletisim",
    path: "/management/magazam/ayarlar/iletisim",
    meta: iletisim47cSClw0nPMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/magazam/ayarlar/iletisim.vue").then(m => m.default || m)
  },
  {
    name: "management-magazam-ayarlar",
    path: "/management/magazam/ayarlar",
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/magazam/ayarlar/index.vue").then(m => m.default || m)
  },
  {
    name: "management-magazam-ayarlar-profil",
    path: "/management/magazam/ayarlar/profil",
    meta: profilbiuEBuoNBvMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/magazam/ayarlar/profil.vue").then(m => m.default || m)
  },
  {
    name: "management-magazam-ayarlar-sirket-bilgileri",
    path: "/management/magazam/ayarlar/sirket-bilgileri",
    meta: sirket_45bilgilerijVzYoanZLpMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/magazam/ayarlar/sirket-bilgileri.vue").then(m => m.default || m)
  },
  {
    name: "management-markalar-id",
    path: "/management/markalar/:id()",
    meta: _91id_93XYCihveGIlMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/markalar/[id].vue").then(m => m.default || m)
  },
  {
    name: "management-markalar-ekle",
    path: "/management/markalar/ekle",
    meta: eklewOck3IsX0ZMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/markalar/ekle.vue").then(m => m.default || m)
  },
  {
    name: "management-markalar",
    path: "/management/markalar",
    meta: indexrVcaQYBcXMMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/markalar/index.vue").then(m => m.default || m)
  },
  {
    name: "management-siparisler-id",
    path: "/management/siparisler/:id()",
    meta: _91id_931AE0eUV4M3Meta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/siparisler/[id].vue").then(m => m.default || m)
  },
  {
    name: "management-siparisler",
    path: "/management/siparisler",
    meta: indexFoeVnhP0G9Meta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/siparisler/index.vue").then(m => m.default || m)
  },
  {
    name: "management-urunler-id",
    path: "/management/urunler/:id()",
    meta: _91id_93fniQ7ErrBEMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/urunler/[id].vue").then(m => m.default || m)
  },
  {
    name: "management-urunler",
    path: "/management/urunler",
    meta: indexf5oTDSTuFFMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/urunler/index.vue").then(m => m.default || m)
  },
  {
    name: "management-urunler-urun-ekle",
    path: "/management/urunler/urun-ekle",
    meta: urun_45ekleoz9fJkWF6CMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/urunler/urun-ekle.vue").then(m => m.default || m)
  },
  {
    name: "management-uyeler",
    path: "/management/uyeler",
    meta: index7I8GJ9OUMfMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/management/uyeler/index.vue").then(m => m.default || m)
  },
  {
    name: "markalar-yeni",
    path: "/markalar/yeni",
    meta: yeniFMQRCWwVQsMeta || {},
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/markalar/yeni.vue").then(m => m.default || m)
  },
  {
    name: "odeme",
    path: "/odeme",
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/odeme.vue").then(m => m.default || m)
  },
  {
    name: "sepet",
    path: "/sepet",
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/sepet.vue").then(m => m.default || m)
  },
  {
    name: "sifremi-unuttum",
    path: "/sifremi-unuttum",
    component: () => createClientPage(() => import("/home/binaffan.com/nuxt-frontend/pages/sifremi-unuttum.client.vue").then(m => m.default || m))
  },
  {
    name: "sikca-sorulan-sorular",
    path: "/sikca-sorulan-sorular",
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/sikca-sorulan-sorular.vue").then(m => m.default || m)
  },
  {
    name: "tesekkurler",
    path: "/tesekkurler",
    component: () => createClientPage(() => import("/home/binaffan.com/nuxt-frontend/pages/tesekkurler.client.vue").then(m => m.default || m))
  },
  {
    name: "tuccar-basvuru-pazaryeri",
    path: "/tuccar/basvuru/pazaryeri",
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/tuccar/basvuru/pazaryeri/index.vue").then(m => m.default || m)
  },
  {
    name: "tuccar-basvuru-tesekkurler",
    path: "/tuccar/basvuru/tesekkurler",
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/tuccar/basvuru/tesekkurler.vue").then(m => m.default || m)
  },
  {
    name: "urun-brand-slug",
    path: "/urun/:brand()/:slug()",
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/urun/[brand]/[slug].vue").then(m => m.default || m)
  },
  {
    name: "urun-slug--urlParams",
    path: "/urun/:slug()--:urlParams()",
    component: () => import("/home/binaffan.com/nuxt-frontend/pages/urun/[slug]--[urlParams].vue").then(m => m.default || m)
  }
]